import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './MainSidebar.css';
import { MdDashboard } from 'react-icons/md';
import { FaChair, FaSignOutAlt, FaExpand, FaCompress, FaUsers } from 'react-icons/fa';
import { IoRestaurant } from "react-icons/io5";
import { MdEmail } from "react-icons/md";



const MainSidebar = () => {
  const { user, signOut } = useAuth();
  const [isNotDesktop, setIsNotDesktop] = useState(window.innerWidth <= 1350);
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsNotDesktop(window.innerWidth <= 1350);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleFullscreen = () => {
    if (!document.fullscreenElement && !document.webkitFullscreenElement && !document.mozFullScreenElement) {
      // Enter fullscreen
      const element = document.documentElement;
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      }
      setIsFullscreen(true);
    } else {
      // Exit fullscreen
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      }
      setIsFullscreen(false);
    }
  };

  const screens = [
    { id: 'floor-plan', name: 'Резервации', icon: <FaChair />, path: '/floor-plan' },
    { id: 'customers', name: 'Гости', icon: <FaUsers />, path: '/customers' },
    { id: 'edit', name: 'Локал', icon: <IoRestaurant />, path: '/edit' },
    { id: 'mail', name: 'Мејлови', icon: <MdEmail />, path: '/email' },


  ];

  const logoSrc = isNotDesktop
    ? 'https://qglldlnkkypojvppmqzs.supabase.co/storage/v1/object/public/restoranisliki//logonotext.png'
    : 'https://qglldlnkkypojvppmqzs.supabase.co/storage/v1/object/public/restoranisliki//logo_with_text.png';

  return (
    <div className="main-sidebar">
      <img
        className="logo"
        src={logoSrc}
        style={{ display: 'block', margin: '0 auto' }}
        alt="Restaurant Logo"
      />
      <div className="sidebar-tabs">
        {screens.map(screen => (
          <NavLink
            key={screen.id}
            to={screen.path}
            className={({ isActive }) => `sidebar-tab ${isActive ? 'active' : ''}`}
            aria-label={screen.name}
          >
            <span className="sidebar-icon">{screen.icon}</span>
            <span className="sidebar-text">{screen.name}</span>
          </NavLink>
        ))}
      </div>
      {user && (
        <div className="sidebar-footer">
          <button
            onClick={toggleFullscreen}
            className="fullscreen-button"
            aria-label={isFullscreen ? 'Exit Fullscreen' : 'Enter Fullscreen'}
          >
            <span className="sidebar-icon">{isFullscreen ? <FaCompress /> : <FaExpand />}</span>
            <span className="sidebar-text">{isFullscreen ? 'Излези од цел екран' : 'Цел екран'}</span>
          </button>
          <button
            onClick={signOut}
            className="sign-out-button"
            aria-label="Sign Out"
          >
            <span className="sidebar-icon"><FaSignOutAlt /></span>
            <span className="sidebar-text">Одјави се</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default MainSidebar;